import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="apropos" data-testid="about-section" className="bg-choco text-ivory py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 md:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-5"
        >
          <div className="aspect-[3/4] overflow-hidden bg-[#23262B]">
            <img
              src="/images/karine.jpg"
              alt="Karine, fondatrice de KARYNA"
              className="w-full h-full object-cover object-[center_25%]"
              loading="lazy"
            />
          </div>
          <div className="mt-8 text-center" data-testid="about-signature-brand">
            <p className="font-serif text-2xl tracking-[0.25em] text-ivory">KARYNA</p>
            <p className="mt-2 font-accent italic text-base text-gold">
              Bien-être ✦ Mouvement ✦ Style ✦ Voyage ✦ Décoration
            </p>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
          className="md:col-span-7"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-gold">À propos</p>
          <h2 className="font-serif text-3xl sm:text-4xl font-light mt-4">La lettre de la fondatrice</h2>
          <div className="mt-8 space-y-5 text-base font-light leading-relaxed text-ivory/85 max-w-xl">
            <p>
              L'Univers de KARYNA est né d'une envie de transmettre aux femmes le bien-être,
              le mouvement et le plaisir de prendre soin de soi au quotidien.
            </p>
            <p>
              J'ai choisi ce nom en hommage à mes parents, dont je souhaite honorer la mémoire
              à travers cette marque. KARYNA est aussi un clin d'œil à ma mère, m'ayant offert
              mon prénom Karine, et à son étoile, une façon personnelle de garder un lien
              avec elle.
            </p>
            <p>
              Bien-être, mouvement, style et voyage se rencontrent ici autour d'une même
              envie : se sentir bien, bouger, voyager et profiter pleinement de la vie.
            </p>
          </div>
          <p className="mt-10 font-accent italic text-3xl text-gold" data-testid="signature-karine">Karine</p>
        </motion.div>
      </div>
    </section>
  );
}
